import { render, staticRenderFns } from "./SendSmsButton.vue?vue&type=template&id=574073ce&scoped=true"
import script from "./SendSmsButton.vue?vue&type=script&lang=js"
export * from "./SendSmsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574073ce",
  null
  
)

export default component.exports